import { Component, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { ImageCropperComponent, CropperSettings, Bounds } from 'ngx-img-cropper';
import { AppCommonService } from "../../../shared/services/app.common.service";
import {  SelectedProfileImageModel } from "../myprofile.model";

@Component({
  selector: "risk-crop-image",
  templateUrl: "./crop-image.component.html",
  styleUrls: ["./crop-image.component.scss"]
})
export class CropImageComponent implements  OnDestroy {
  errorMessage:string=null;

  data: any;
  cropperSettings: CropperSettings;

  @ViewChild('cropper')
  cropper: ImageCropperComponent;

  /**File upload variables**/
  allowedFileTypes: string[] = ["jpg", "jpeg", "png", "bmp"];
  selectedFile: SelectedProfileImageModel;
  @ViewChild("fileUpload") fileUpload: ElementRef;

  uploadButtonText:"Select File"|"Change File";

  isInvalidFile:boolean=true;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {Renderer2} _renderer
   * @param {CookieService} _cookieService
   * @param {FuseMatchMediaService} _fuseMatchMediaService
   * @param {FuseNavigationService} _fuseNavigationService
   * @param {ObservableMedia} _observableMedia
   */
  constructor(
    public matDialogRef: MatDialogRef<CropImageComponent>,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    this.cropperSettings = new CropperSettings();
    this.cropperSettings.minWidth = 100;
    this.cropperSettings.minHeight = 100;
    this.cropperSettings.croppedWidth = 128;
    this.cropperSettings.croppedHeight = 128;
    this.cropperSettings.canvasWidth = 300;
    this.cropperSettings.canvasHeight = 300;
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.rounded = true;
    this.data = {};

    this.uploadButtonText = "Select File";
  }
  

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  onClickTriggerFileInput() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.click();
  }
  
  fileChangeListener($event) {  
    if ($event.target.files.length > 0) {
      const file = $event.target.files[0];
      var fileExtension = AppCommonService.getFileExtension(file.name);

      /**File must be image file and less than 2 MB**/
      if (!this.allowedFileTypes.includes(fileExtension) || file.size > 2097152) {
        this.errorMessage = !this.allowedFileTypes.includes(fileExtension)
          ? "Invalid file type"
          : "File Must be less than 2 Mb in size";
        this.selectedFile = null;
        this.data = {};
        this.isInvalidFile = true;
        this.cropper.reset();
        return;
      }
      this.errorMessage = null;
      this.isInvalidFile = false;
      this.uploadButtonText = "Change File";
      this.selectedFile = new SelectedProfileImageModel(file, file.name);

      var image: any = new Image();
      var myReader: FileReader = new FileReader();
      myReader.onloadend = (loadEvent: any) => {
        image.src = loadEvent.target.result;
        this.cropper.setImage(image);
      };
      myReader.readAsDataURL(file);
    }
  }
  
}
